import { withSafeSuspense } from '@calendly/safe-suspense'
import { lazy } from 'react'

export const Login = withSafeSuspense(lazy(
  async () => ({ default: (await import('./login')).Login })
))
